import { DatePipe } from '@angular/common';
import { ArrayLimitToPipe } from '../../filters/array-limit-to.pipe';
import { StartFromPipe } from '../../filters/start-from.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { ListConsentsComponent } from '../../components/list-consents/list-consents.component';
import { ItemNotificationComponent } from '../../components/item-notification/item-notification.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import { Input } from '@angular/core';
import { PanelDirective } from '../../directives/panel.directive';
import Session from '../../utils/session.service';
import Config from '../../utils/config.service';

@Component({
	standalone: true,
	selector: 'table-consents',
	templateUrl: './table-consents.component.html',
	imports: [
		CommonModule, PanelDirective, DatePipe, ArrayLimitToPipe, StartFromPipe, 
		TranslatePipe, ListConsentsComponent, ItemNotificationComponent, FormsModule
	]
})
export class TableConsentsComponent implements OnInit {
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private session: Session = inject(Session);
	private config: Config = inject(Config);
	
	@Input() consents: any;
	@Input() pageSize: any | undefined;
	@Input() currentPage: any | undefined;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.user = this.session.getSession().user;
		var origin: any = (this.vm.user && this.vm.user.origin) ? this.vm.user.origin : "minudoc.ee";
		var locale: any = this.vm.user?.deviceLanguage;
		this.vm.webUrl = this.config.getPublicWebUrl();
		if (origin == 'minudoc.ee') {
			switch (this.vm.user.deviceLanguage) {
				case 'et_EE':
					this.vm.webPathTos = '/kasutustingimused';
					this.vm.webPathPP = '/privaatsuspoliis';
					break;
				case 'ru_RU':
					this.vm.webPathTos = '/uslovija-ispolzovanija';
					this.vm.webPathPP = '/politika-konfidencialnosti';
					break;
				case 'fi_FI':
					this.vm.webPathTos = '/kayttoehdot';
					this.vm.webPathPP = '/tietosuojakaytanto';
					break;
				default:
					this.vm.webPathTos = '/terms-of-service';
					this.vm.webPathPP = '/privacy-policy';
			}
		} else {
			this.vm.webPathTos = '/terms-of-service';
			this.vm.webPathPP = '/privacy-policy';
		}
		this.vm.webTosLink = origin == 'siffi.com'
			? this.config.getSiffiPublicWebUrl(locale, this.vm.webPathTos)
			: this.vm.webUrl + this.vm.webPathTos;
		this.vm.webPPLink = origin == 'siffi.com'
			? this.config.getSiffiPublicWebUrl(locale, this.vm.webPathPP)
			: this.vm.webUrl + this.vm.webPathPP;
		

		
		this.vm.pageSize = this.vm.pageSize || 10;
		this.vm.currentPage = this.vm.currentPage || 0;
		this.vm.defaultNotificationText = this.angularFilterHelperService.translate('Modal.Content.Consent_State_Change_Info1')
			+ ' ' + this.angularFilterHelperService.translate('Modal.Content.Consent_State_Change_Info2');
		this.vm.gdprNotificationText = this.angularFilterHelperService.translate('Modal.Content.Consents_Gdpr_Disclaimer');
	};
	
	getNotificationText(consent: any) {
		if (consent.notificationText) {
			return consent.notificationText;
		}

		var isBookingConsent = typeof consent.booking !== 'undefined';
		if (isBookingConsent 
				&& consent.booking.service
				&& consent.booking.service.minudocExtraConsentsDisabled) {
			consent.notificationText = this.vm.gdprNotificationText;
		} else {
			consent.notificationText = this.vm.defaultNotificationText;
		}
		
		return consent.notificationText;
	}
	
}
